import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo, memo } from 'react';
import { OLAF } from 'HubStyleTokens/colors';
import UICheckbox from 'UIComponents/input/UICheckbox';
import { useTableDispatch, useTableSelector } from '../../redux/reduxHooks';
import { makeGetIsRowSelected, setRowsSelected } from '../redux/selectionSlice';
import styled from 'styled-components';
import UIFlex from 'UIComponents/layout/UIFlex';
const CheckboxTD = styled.td.withConfig({
  displayName: "SelectRowCheckboxCell__CheckboxTD",
  componentId: "sc-19lya39-0"
})(["border-left-width:0 !important;"]);
const StickyCheckboxTD = styled(CheckboxTD).withConfig({
  displayName: "SelectRowCheckboxCell__StickyCheckboxTD",
  componentId: "sc-19lya39-1"
})(["background-color:", ";left:0;position:sticky;"], OLAF);
const FullUIFlex = styled(UIFlex).withConfig({
  displayName: "SelectRowCheckboxCell__FullUIFlex",
  componentId: "sc-19lya39-2"
})(["width:100%;height:100%;"]);

const SelectRowCheckboxCell = ({
  numberOfFrozenColumns = 0,
  rowId
}) => {
  const getIsRowSelected = useMemo(() => makeGetIsRowSelected(rowId), [rowId]);
  const isSelected = useTableSelector(getIsRowSelected);
  const dispatch = useTableDispatch();
  const handleChange = useCallback(({
    target: {
      checked
    }
  }) => dispatch(setRowsSelected([{
    rowId,
    selected: checked
  }])), [dispatch, rowId]);
  const Component = numberOfFrozenColumns > 0 ? StickyCheckboxTD : CheckboxTD;
  return /*#__PURE__*/_jsx(Component, {
    className: "p-all-0",
    children: /*#__PURE__*/_jsx(FullUIFlex, {
      align: "center",
      justify: "center",
      children: /*#__PURE__*/_jsx(UICheckbox, {
        "data-test-id": `checkbox-select-row-${rowId}`,
        checked: isSelected,
        onChange: handleChange
      })
    })
  });
};

export default /*#__PURE__*/memo(SelectRowCheckboxCell);